import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-shared-button',
  templateUrl: './shared-button.component.html',
  styleUrls: ['./shared-button.component.scss']
})
export class SharedButtonComponent {
  @Input() button_class: string = 'sp-button__main';
	@Input() spinner_class?: string = 'sp-spinner__main';
	@Input() cta: string = '';
	@Input() icon?: string;
	@Input() icon_class?: string;
	@Input() is_disabled?: boolean;
	@Input() is_spinner_visible?: boolean;
	@Output() button_click: EventEmitter<void> = new EventEmitter<void>();
}
